module.exports = {
	slideDown: require('./slideDown'),
	slideUp: require('./slideUp')
};